// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[v-cloak] > *[data-v-6a69aae8] {\r\n\tdisplay: none !important;\n}\n.select-wrapper[data-v-6a69aae8] {\r\n\tmin-width: 210px !important;\r\n\twidth: 210px !important;\n}\n#rootVM > .panel .panel-body .form-group[data-v-6a69aae8] {\r\n\tdisplay: flex;\r\n\talign-items: center;\n}\n#rootVM > .panel .panel-body .form-group label[data-v-6a69aae8] {\r\n\twidth: 60%;\r\n\tmargin-top: 5px;\r\n\tmax-width: 130px;\n}\r\n", ""]);
// Exports
module.exports = exports;
